import { render, staticRenderFns } from "./EmployeePosition.vue?vue&type=template&id=568e2778&"
import script from "./EmployeePosition.vue?vue&type=script&lang=js&"
export * from "./EmployeePosition.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports